import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const fallbackLng = 'en-GB'
const localeVersion = import.meta.env.VITE_RELEASE
const localeLoadPath = localeVersion
  ? `/locale/{{lng}}/{{ns}}.json?v=${encodeURIComponent(localeVersion)}`
  : '/locale/{{lng}}/{{ns}}.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    backend: {
      loadPath: localeLoadPath,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    load: 'currentOnly',
    defaultNS: 'common',
    // Only namespaces needed before any authenticated route (sign-in, sign-up, language switcher).
    // Everything else is loaded on demand when `useTranslation(ns)` or `t(key, { ns })` runs.
    // 3PL uses multiple `three-pl-*` namespaces (see `public/locale/en-GB/three-pl-*.json`); English-only
    // for now, forced in main-3pl. Not part of Lex `auth`.
    ns: ['common', 'auth'],
    fallbackLng,
    supportedLngs: ['en-GB', 'de-DE', 'zh-CN'],
    // React already escapes JSX text; i18next's HTML escaping turns `'` into visible `&#39;`.
    interpolation: {
      escapeValue: false,
    },
  })
